require('videogular');
require('./vg-controls');

module.exports = 'com.2fdevs.videogular.plugins.controls';



// WEBPACK FOOTER //
// ./node_modules/videogular-controls/index.js